import 'core-js/modules/es.function.name';
import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.reflect.construct';
import 'core-js/modules/es.regexp.to-string';
import _classCallCheck from '/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/createClass';
import _get from '/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/get';
import _inherits from '/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/getPrototypeOf';
function _createSuper(Derived) {
    function isNativeReflectConstruct() {
        if (typeof Reflect === 'undefined' || !Reflect.construct)
            return false;
        if (Reflect.construct.sham)
            return false;
        if (typeof Proxy === 'function')
            return true;
        try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function () {
            }));
            return true;
        } catch (e) {
            return false;
        }
    }
    return function () {
        var Super = _getPrototypeOf(Derived), result;
        if (isNativeReflectConstruct()) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/editableui/inline/inlineeditableuiview
 */
import EditableUIView from '../../editableui/editableuiview';
/**
 * The inline editable UI class implementing an inline {@link module:ui/editableui/editableuiview~EditableUIView}.
 *
 * @extends module:ui/editableui/editableuiview~EditableUIView
 */
var InlineEditableUIView = /*#__PURE__*/
function (_EditableUIView) {
    _inherits(InlineEditableUIView, _EditableUIView);
    var _super = _createSuper(InlineEditableUIView);
    /**
   * Creates an instance of the InlineEditableUIView class.
   *
   * @param {module:utils/locale~Locale} [locale] The locale instance.
   * @param {module:engine/view/view~View} editingView The editing view instance the editable is related to.
   * @param {HTMLElement} [editableElement] The editable element. If not specified, the
   * {@link module:ui/editableui/editableuiview~EditableUIView}
   * will create it. Otherwise, the existing element will be used.
   */
    function InlineEditableUIView(locale, editingView, editableElement) {
        var _this;
        _classCallCheck(this, InlineEditableUIView);
        _this = _super.call(this, locale, editingView, editableElement);
        _this.extendTemplate({
            attributes: {
                role: 'textbox',
                class: 'ck-editor__editable_inline'
            }
        });
        return _this;
    }
    /**
   * @inheritDoc
   */
    _createClass(InlineEditableUIView, [{
            key: 'render',
            value: function render() {
                var _this2 = this;
                _get(_getPrototypeOf(InlineEditableUIView.prototype), 'render', this).call(this);
                var editingView = this._editingView;
                var t = this.t;
                editingView.change(function (writer) {
                    var viewRoot = editingView.document.getRoot(_this2.name);
                    writer.setAttribute('aria-label', t('Редактор, %0', [_this2.name]), viewRoot);
                });
            }
        }]);
    return InlineEditableUIView;
}(EditableUIView);
export {
    InlineEditableUIView as default
};